import { agreementContentLooksLikeHtml } from '../widget-lib/agreement-content-format';
import { RichTextBlock } from './rich-text-block';

/** Блок текста соглашения — без ограничения высоты, карточка на всю ширину. */
export const LEGAL_AGREEMENT_HTML_BOX_CLASS =
  'rounded-sm border border-[var(--border)] bg-[var(--bg-elevated)] p-4 text-sm leading-relaxed text-[var(--text)] [&_a]:text-[var(--accent)] [&_a]:underline [&_li]:mb-1 [&_p]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5';

type LegalAgreementHtmlBlockProps = {
  /** HTML или Markdown — формат определяется автоматически. */
  html: string;
};

export function LegalAgreementHtmlBlock({ html }: LegalAgreementHtmlBlockProps) {
  if (!html?.trim()) {
    return null;
  }
  const asHtml = agreementContentLooksLikeHtml(html);
  return (
    <div className={LEGAL_AGREEMENT_HTML_BOX_CLASS}>
      <RichTextBlock
        html={html}
        format={asHtml ? 'html' : 'markdown'}
        className="text-sm leading-relaxed text-[var(--text)]"
      />
    </div>
  );
}
